import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import MatSelect from '@material-ui/core/Select';

import ClientRequestService from 'services/ClientRequestService';

export default class Select extends Component {
    constructor(props) {
        super(props);
        this.dataHandlerService = new ClientRequestService();

        this.state = {
            options: []
        }
    }

    componentDidUpdate(prevProps) {
        var that = this;

        if (prevProps.url && prevProps.url !== this.props.url && !this.props.options.length) {
            this.dataHandlerService.Get({
                url: this.props.url,
                withModule: this.props.withModule
            }).then(comboSource => {
                that.setState({
                    options: comboSource ? comboSource : []
                }, () => {
                    if (typeof (this.props.loadComplete) === 'function') {
                        this.props.loadComplete(comboSource, this.props.rowIndex);
                    }
                });
            });
        }
    }

    componentDidMount() {
        var that = this;

        if (this.props.url && !this.props.options.length) {
            this.dataHandlerService.Get({
                url: this.props.url,
                withModule: this.props.withModule
            }).then(comboSource => {
                that.setState({
                    options: comboSource ? comboSource : []
                });
            });
        }
    }

    render() {
        const {
            id, label, options, value, name, helperText,
            onChange, onFocus, onBlur, error, disabled, required
        } = this.props;

        let workingOptions = !options.length ? this.state.options : options;
        const { valueMapper, textMapper, descMapper } = this.props.mapper ? this.props.mapper : { valueMapper: 'value', textMapper: 'text', descMapper: 'desc' };

        return (id ?
            <FormControl className={this.props.className} {...(required ? { required } : {})} style={{ width: '100%' }}>
                <InputLabel id={id} error={error}>{label}</InputLabel>
                <MatSelect labelId={id} name={name} value={value} onChange={onChange} onFocus={onFocus} onBlur={onBlur} error={error} disabled={disabled}>
                    <MenuItem value=''>
                        <em>None</em>
                    </MenuItem>
                    {
                        workingOptions.map((option, index) =>
                            <MenuItem key={index} value={option[valueMapper]} desc={option[descMapper]}>
                                {option[textMapper]}
                            </MenuItem>
                        )
                    }
                </MatSelect>
                <FormHelperText>{helperText}</FormHelperText>
            </FormControl> :
            <MatSelect style={{ width: '100%' }} value={value} onChange={onChange} disabled={disabled}>
                <MenuItem value=''>
                    <em>None</em>
                </MenuItem>
                {
                    workingOptions.map((option, index) =>
                        <MenuItem key={index} value={option[valueMapper]} desc={option[descMapper]}>
                            {option[textMapper]}
                        </MenuItem>
                    )
                }
            </MatSelect>
        );
    }
}
